/*

<![CDATA[

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var TreeView = kendo.ui.TreeView;
    if (!TreeView || TreeView.updated) return;

    var ui = kendo.ui,
        Widget = ui.Widget,
        CHECKBOX = '[type="checkbox"]',
        proxy = $.proxy;

    var oldTreeViewInit = TreeView.fn.init;

    TreeView = TreeView.extend({

        init: function (element, options) {
            var self = this,
                isCustomCheckBoxEnabled = $.prototype.kendoCheckBox !== undefined,
                oldDataBoundHandler,
                oldCheckHandler;

            if (options === undefined) {
                options = {};
            }
            if (typeof options.dataBound == "function") {
                oldDataBoundHandler = options.dataBound;
            }
            if (typeof options.check == "function") {
                oldCheckHandler = options.check;
            }

            $.extend(options, {
                dataBound: function (e) {
                    if (isCustomCheckBoxEnabled) {
                        // initialize custom checkboxes (only if they're not already initialized)
                        this.element.find(CHECKBOX).filter(function () { return $(this).prev('.checkbox-icon').length == 0 }).kendoCheckBox();
                    }
                    if (oldDataBoundHandler !== undefined) {
                        proxy(oldDataBoundHandler, this)(e);
                    }
                },
                check: function (e) {
                    if (isCustomCheckBoxEnabled) {
                        var $checkboxes = this.element.find(CHECKBOX);
                        // IE fires checkbox click event just after this method is executed, so we need to wait a bit
                        setTimeout(function () {
                            $checkboxes.each(function () {
                                $(this).data('kendoCheckBox').value(this.checked);
                            });
                        });
                    }
                    if (oldCheckHandler !== undefined) {
                        proxy(oldCheckHandler, this)(e);
                    }
                }
            });

            oldTreeViewInit.call(self, element, options);
        },

        options: kendo.getUpdatedWidgetOptions(),

        /**
         * Destroys the widget.
         */
        destroy: function () {
            var self = this;
            Widget.fn.destroy.call(self);
        }

    });

    TreeView.updated = true;

    ui.plugin(TreeView);

})(window.kendo.jQuery);

/* ]]> */